angular.module("garanzieAccessorie.components",[])
.component("garanzieAccessorie",{
    templateUrl: 'ng/components/riepilogoEControllo/garanzieAccessorie/garanzieAccessorie.view.html',
    bindings:{
        model:'<',
        verifica:'=',
        readOnly:'<'
    },
    controller: GaranzieAccessorie,
    controllerAs: 'garAccessorieCtrl'
})

function GaranzieAccessorie(
    $timeout,
    $configService
){
    var self= this;

    self.$onInit = function(){
        self.supportModel={
            guarSelected:[],
            warrantyList: self.model,
            maxGuarLength: 50,
            enableToltipGuar:[]

        }
        populateGuarTable();
    }

    var populateGuarTable = function () {
        var guarList = "";
        self.supportModel.guarSelected = [];
        for (var i = 0; i < self.supportModel.warrantyList.length; i++) {
            self.supportModel.warrantyList[i].listaGaranti.forEach(function (el) {
                if (el.garante.selected) {
                    guarList += el.denominazione;
                    guarList += "; ";
                    if (self.supportModel.guarSelected.length > 0) {
                        self.supportModel.guarSelected[i] = [];
                        self.supportModel.guarSelected[i] = guarList;
                    } else {
                        self.supportModel.guarSelected[0] = guarList;
                    }
                }
            })
            guarList = "";
        }
        checkAndEnableTooltip();
    }

    var checkAndEnableTooltip = function () {
        $timeout(function () {
            if (self.supportModel.guarSelected.length > 0) {
                for (var i = 0; i < self.supportModel.guarSelected.length; i++) {
                    if (self.supportModel.guarSelected[i].length > self.supportModel.maxGuarLength) {
                        self.supportModel.enableToltipGuar[i] = true;
                    } else {
                        self.supportModel.enableToltipGuar[i] = false;
                    }
                }
            }
        }, 1000);
    }

    self.check= function(el){
        el.selected = !el.selected;
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }
}